<div class="login-page">
  <div class="page-wrap">
    <div class="form-wrapper">
        <div class=" otp-modal-content">
        <div class="otp-body">
            <h2 class="otp-title">OTP Verification</h2>

            <div class="otp-info-box">
            <div class="otp-info-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V9H11V15ZM11 7H9V5H11V7Z" fill="#888"/>
                </svg>
            </div>
            <div class="otp-info-text">
                Please enter the 4-digit verification code sent to {{ maskEmail(registeredEmail) }}
            </div>
            </div>

            <div class="otp-input-section">
            <label class="otp-label">Enter OTP</label>
            <div class="otp-digits" [class.otp-digits-error]="otpError">
                <input #otpInput0 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
                [(ngModel)]="otpDigits[0]" (input)="onOtpDigitInput($event, 0)" (keydown)="onOtpKeyDown($event, 0)" (paste)="onOtpPaste($event)" />
                <input #otpInput1 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
                [(ngModel)]="otpDigits[1]" (input)="onOtpDigitInput($event, 1)" (keydown)="onOtpKeyDown($event, 1)" (paste)="onOtpPaste($event)" />
                <input #otpInput2 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
                [(ngModel)]="otpDigits[2]" (input)="onOtpDigitInput($event, 2)" (keydown)="onOtpKeyDown($event, 2)" (paste)="onOtpPaste($event)" />
                <input #otpInput3 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
                [(ngModel)]="otpDigits[3]" (input)="onOtpDigitInput($event, 3)" (keydown)="onOtpKeyDown($event, 3)" (paste)="onOtpPaste($event)" />
            </div>
            </div>

            <div class="otp-resend-row" *ngIf="!otpError">
            <ng-container *ngIf="resendCooldown > 0">
                Didn't receive code? Resend code in <span class="otp-timer">{{ resendCooldown }}s</span>
            </ng-container>
            <ng-container *ngIf="resendCooldown === 0">
                Didn't receive code? Click <a class="otp-resend-link" (click)="resendOtp()">here</a> to resend another code
            </ng-container>
            </div>

            <div class="otp-error-row" *ngIf="otpError && otpExpired">
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#dc3545"/>
            </svg>
            <span>{{ otpError }} Click <a class="otp-resend-link" (click)="resendOtp()">here</a> to resend another code</span>
            </div>

            <div class="otp-error-row" *ngIf="otpError && !otpExpired">
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#dc3545"/>
            </svg>
            <span>{{ otpError }}</span>
            </div>

            <button class="btn otp-continue-btn" (click)="verifyOtp()" [disabled]="otpLoading">
            {{ otpLoading ? 'Verifying...' : 'Continue' }}
            </button>
            <button type="button" #openRegisterSuccessModal hidden data-bs-toggle="modal" data-bs-target="#registerSuccess"></button>
        </div>
        </div>
    </div>
  </div>
</div>

<div class="modal fade" id="registerSuccess">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content success-modal-content">
      <div class="modal-header close-reg-modal">
        <div class="header-x" #closeModal data-bs-dismiss="modal" (click)="closeSuccessfullRegistrationModal()">
          <img src="../../../assets/solid.svg" alt="" />
        </div>
      </div>
      <div class="content text-center success-content">
        <div class="success-icon">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="#21935C"/>
          </svg>
        </div>
        <div class="success-title">OTP verification successfull</div>
        <div class="success-subtitle">Your email has been confirmed</div>
        <div class="proceed-div">
          <button class="btn success-btn" (click)="proceedToLogin()">Proceed to Login</button>
        </div>
      </div>
    </div>
  </div>
</div>
